import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["confirmPasswordModal", "confirmPasswordForm"]

  connect() {
    this.initializeBackNavigationCapture()
  }

  submitConfirmPasswordForm(_) {
    this.confirmPasswordFormTarget.submit()
  }

  initializeBackNavigationCapture(_) {
    history.pushState(null, document.title, location.href)
    window.addEventListener("popstate", function(_) {
      history.pushState(null, document.title, location.href)
    })
  }
}
